module.exports = __webpack_public_path__ + "static/media/add-plus.782f154f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/add-plus.png
// module id = 894
// module chunks = 0